<template>
  <div class="committee-draft-contract-page figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">
          <span :class="['child-tab-title', { 'is-muted': activeChildTab === 'add' }]" @click="openListTab">{{ $t('committeeDraftContract.pageTitle') }}</span>
          <template v-if="activeChildTab === 'add'">
            <span class="child-tab-separator">&gt;</span>
            <span class="child-tab-title is-active">{{ $t('committeeDraftContract.action.addDraft') }}</span>
          </template>
          <template v-if="activeChildTab === 'edit'">
            <span class="child-tab-separator">&gt;</span>
            <span class="child-tab-title is-active">{{ $t('committeeDraftContract.action.edit') }}</span>
          </template>
          <el-button v-if="activeChildTab !== 'list'" size="small" class="figma-btn-back" @click="openListTab">{{ $t('committeeDraftContract.action.back') }}</el-button>
        </div>
        <div class="figma-header-divider"></div>
        <div v-if="activeChildTab === 'list'" class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-draft" @click="handleAdd">
              <img src="../../../assets/CodeBuddyAssets/616_9044/29.svg" class="figma-btn-icon" />
              <span>{{ $t('committeeDraftContract.action.draft') }}</span>
            </el-button>
            <el-button size="small" class="figma-btn-refresh" :title="$t('committeeDraftContract.action.refresh')" @click="getList">
              <img src="../../../assets/CodeBuddyAssets/616_9044/28.svg" class="figma-refresh-icon" />
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input
              v-model.trim="conditions.contractNameLike"
              size="small"
              :placeholder="$t('committeeDraftContract.search.contractNamePlaceholder')"
              class="figma-search-input"
              clearable
              @keyup.enter.native="handleSearch"
            />
            <el-input
              v-model.trim="conditions.contractCode"
              size="small"
              :placeholder="$t('committeeDraftContract.search.contractCodePlaceholder')"
              class="figma-search-input"
              clearable
              @keyup.enter.native="handleSearch"
            />
            <el-select
              v-model="conditions.contractType"
              size="small"
              :placeholder="$t('committeeDraftContract.search.contractTypePlaceholder')"
              class="figma-search-input"
              clearable
              @change="handleSearch"
            >
              <el-option v-for="item in contractTypes" :key="item.contractTypeId" :label="item.typeName" :value="item.contractTypeId" />
            </el-select>
            <el-button size="small" class="figma-btn-search" @click="handleSearch">
              <img src="../../../assets/CodeBuddyAssets/616_9044/33.svg" class="figma-search-icon" />
              <span>{{ $t('committeeDraftContract.action.search') }}</span>
            </el-button>
          </div>
        </div>
      </div>

        <template v-if="activeChildTab === 'list'">
        <div class="figma-table-section">
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%"
            :fit="true"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle"
          >
            <el-table-column prop="communityName" :label="$t('committeeDraftContract.table.communityName')" min-width="152" show-overflow-tooltip />
            <el-table-column prop="contractCode" :label="$t('committeeDraftContract.table.contractCode')" min-width="139" show-overflow-tooltip />
            <el-table-column prop="parentContractCode" :label="$t('committeeDraftContract.table.parentContractCode')" min-width="130" show-overflow-tooltip />
            <el-table-column prop="contractTypeName" :label="$t('committeeDraftContract.table.contractType')" min-width="105" show-overflow-tooltip />
            <el-table-column prop="operator" :label="$t('committeeDraftContract.table.operator')" min-width="138" show-overflow-tooltip />
            <el-table-column prop="amount" :label="$t('committeeDraftContract.table.amount')" min-width="258" show-overflow-tooltip />
            <el-table-column prop="startTime" :label="$t('committeeDraftContract.table.startTime')" min-width="172" show-overflow-tooltip />
            <el-table-column prop="endTime" :label="$t('committeeDraftContract.table.endTime')" min-width="172" show-overflow-tooltip />
            <el-table-column :label="$t('committeeDraftContract.table.state')" min-width="136">
              <template slot-scope="scope">
                <span :class="['status-tag', getStateClass(scope.row)]">{{ scope.row.stateName || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('committeeDraftContract.table.action')" min-width="178">
              <template slot-scope="scope">
                <div class="action-links">
                  <a class="action-link" @click="handleEdit(scope.row)">{{ $t('committeeDraftContract.action.edit') }}</a>
                  <span class="link-space"></span>
                  <a class="action-link" @click="handleDelete(scope.row)">{{ $t('committeeDraftContract.action.delete') }}</a>
                  <span class="link-space"></span>
                  <a class="action-link" @click="handlePrint(scope.row)">{{ $t('committeeDraftContract.action.print') }}</a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="figma-pagination">
          <span class="pagination-total">共{{ pagination.total }}条</span>
          <el-pagination
            :current-page="pagination.page"
            :page-size="pagination.row"
            layout="prev, pager, next"
            :total="pagination.total"
            @current-change="handlePageChange"
          />
          <el-select v-model="pagination.row" size="small" class="pagination-size-select" @change="handleSizeChange">
            <el-option label="10条/页" :value="10" />
            <el-option label="20条/页" :value="20" />
            <el-option label="50条/页" :value="50" />
          </el-select>
        </div>
      </template>

      <draft-contract-form
        v-else
        ref="draftForm"
        class="draft-add-child"
        :community-list="communityList"
        :edit-data="editRowData"
        @back="openListTab"
        @success="handleAddSuccess"
      />
    </div>

    <edit-contract ref="editContract" @success="getList" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { getContractList, getContractTypeList, deleteContract } from '@/api/contract/newContractManageApi'
import { listCommunitysByOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import EditContract from '@/components/contract/editContract'
import DraftContractForm from './draftContractForm.vue'

export default {
  name: 'CommitteeDraftContractList',
  components: { EditContract, DraftContractForm },
  data() {
    return {
      activeChildTab: 'list',
      loading: false,
      conditions: { contractNameLike: '', contractCode: '', contractType: '' },
      tableData: [],
      contractTypes: [],
      communityList: [],
      pagination: { total: 0, page: 1, row: 10 },
      editRowData: null
    }
  },
  created() { this.initPage() },
  methods: {
    headerCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '400', fontFamily: 'PingFang SC', height: '50px' }
    },
    cellStyle({ row }) {
      const rowIndex = this.tableData.indexOf(row)
      const base = { color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px', fontWeight: rowIndex % 2 === 1 ? '500' : '400' }
      return rowIndex % 2 === 1 ? { ...base, background: '#F8FBFF' } : { ...base, background: 'white' }
    },
    isSuccess(res) {
      return res && (res.code === 0 || res.code === 200 || res.code === '0' || res.code === '200' || res.success || res.msg === 'success')
    },
    getListArray(res) {
      if (Array.isArray(res)) return res
      if (Array.isArray(res && res.data)) return res.data
      if (Array.isArray(res && res.records)) return res.records
      if (Array.isArray(res && res.rows)) return res.rows
      if (Array.isArray(res && res.contracts)) return res.contracts
      return []
    },
    getTotal(res, list) {
      return Number((res && (res.total || res.count || res.totalCount)) || list.length || 0)
    },
    async initPage() {
      await Promise.all([this.loadCommunities(), this.loadContractTypes()])
      this.getList()
    },
    async loadCommunities() {
      try {
        const res = await listCommunitysByOwnerCommittee({ page: 1, row: 1000 })
        this.communityList = res.data || []
      } catch (e) {
        this.communityList = []
      }
    },
    async loadContractTypes() {
      try {
        const res = await getContractTypeList({ page: 1, row: 1000 })
        this.contractTypes = this.getListArray(res)
      } catch (e) {
        this.contractTypes = []
      }
    },
    getCommunityName(row) {
      if (row.communityName) return row.communityName
      const community = this.communityList.find(item => item.communityId === row.communityId)
      return community ? community.name : '-'
    },
    getContractTypeName(row) {
      if (row.contractTypeName) return row.contractTypeName
      const type = this.contractTypes.find(item => item.contractTypeId === row.contractType)
      return type ? type.typeName : (row.contractType || '-')
    },
    normalizeRow(row) {
      return {
        ...row,
        communityName: this.getCommunityName(row),
        contractCode: row.contractCode || '-',
        parentContractCode: row.parentContractCode || '-',
        contractTypeName: this.getContractTypeName(row),
        operator: row.operator || '-',
        amount: row.amount || row.contractAmount || '-',
        startTime: row.startTime || '-',
        endTime: row.endTime || '-',
        stateName: row.stateName || row.statusName || row.state || '-'
      }
    },
    getStateClass(row) {
      const text = String(row.stateName || row.statusName || row.state || '')
      if (text.includes('待') || text.toLowerCase().includes('pending')) return 'status-pending'
      if (text.includes('通过') || text.includes('完成') || text.toLowerCase().includes('pass') || text.toLowerCase().includes('approved')) return 'status-approved'
      return 'status-default'
    },
    async getList() {
      try {
        this.loading = true
        const res = await getContractList({
          page: this.pagination.page,
          row: this.pagination.row,
          contractNameLike: this.conditions.contractNameLike,
          contractCode: this.conditions.contractCode,
          contractType: this.conditions.contractType,
          communityIds: this.communityList.map(c => c.communityId).join(',')
        })
        const list = this.getListArray(res)
        this.tableData = list.map(item => this.normalizeRow(item))
        this.pagination.total = this.getTotal(res, list)
      } catch (e) {
        this.$message.error(this.$t('committeeDraftContract.message.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.pagination.page = 1; this.getList() },
    handleAdd() {
      this.editRowData = null
      this.activeChildTab = 'add'
      this.$nextTick(() => {
        this.$refs.draftForm && this.$refs.draftForm.resetForm()
      })
    },
    openListTab() {
      if (this.activeChildTab !== 'list') {
        this.activeChildTab = 'list'
        this.editRowData = null
        this.getList()
      }
    },
    handleAddSuccess() {
      this.activeChildTab = 'list'
      this.editRowData = null
      this.getList()
    },
    handleEdit(row) {
      this.editRowData = row
      this.activeChildTab = 'edit'
    },
    handlePrint(row) {
      window.open(`/#/views/contract/printContract?contractTypeId=${row.contractType}&contractId=${row.contractId}`)
    },
    handleDelete(row) {
      this.$confirm(this.$t('committeeDraftContract.dialog.deleteConfirm'), this.$t('committeeDraftContract.dialog.deleteTitle'), { type: 'warning' }).then(async () => {
        const res = await deleteContract({ contractId: row.contractId, communityId: row.communityId || getCommunityId() })
        if (!this.isSuccess(res)) throw new Error((res && res.msg) || this.$t('committeeDraftContract.message.deleteError'))
        this.$message.success(this.$t('committeeDraftContract.dialog.deleteSuccess'))
        this.getList()
      }).catch(e => {
        if (e && e.message) this.$message.error(e.message)
      })
    },
    handlePageChange(page) { this.pagination.page = page; this.getList() },
    handleSizeChange(size) { this.pagination.row = size; this.pagination.page = 1; this.getList() }
  }
}
</script>

<style scoped>
.committee-draft-contract-page { height: calc(100vh - 60px); background: #EBF2FA; padding: 0; overflow: hidden; box-sizing: border-box; display: flex; flex-direction: column; }
.figma-white-card { background: white; border-radius: 0 0 12px 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px 12px; gap: 12px; flex-shrink: 0; }
.figma-page-title { font-size: 16px; font-weight: 600; color: #1D2129; font-family: 'PingFang SC'; line-height: 22px; display: flex; align-items: center; gap: 8px; width: 100%; }
.child-tab-title { color: #1D2129; cursor: default; }
.child-tab-title.is-muted { color: #8C9BB4; cursor: pointer; }
.child-tab-title.is-active { color: #1D2129; cursor: default; }
.child-tab-separator { color: #8C9BB4; font-size: 16px; font-weight: 500; }
.figma-btn-back { margin-left: auto; width: 78px; height: 38px; min-height: 38px; padding: 0 !important; background: white !important; border: 1px solid #0E76FF !important; color: #0E76FF !important; border-radius: 10px !important; font-size: 14px; font-weight: 500; display: inline-flex; align-items: center; justify-content: center; }
.figma-btn-back:hover { background: rgba(14, 118, 255, 0.08) !important; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; }
.figma-btn-group { display: flex; align-items: center; gap: 12px; }
.figma-btn-draft { width: 82px; height: 38px; min-height: 38px; padding: 0 !important; background: #0E76FF !important; border: none !important; color: white !important; border-radius: 10px !important; font-size: 14px; font-weight: 500; display: inline-flex; align-items: center; justify-content: center; }
.figma-btn-icon { width: 16px; height: 16px; margin-right: 6px; flex-shrink: 0; }
.figma-refresh-icon { width: 16px; height: 16px; }
.figma-search-icon { width: 16px; height: 16px; flex-shrink: 0; }
.figma-btn-refresh { width: 38px; height: 38px; min-height: 38px; padding: 0 !important; background: white !important; border: 1px solid #DCE6F5 !important; color: #6A7282 !important; border-radius: 10px !important; display: inline-flex; align-items: center; justify-content: center; }
.figma-btn-refresh:hover { border-color: #0E76FF !important; color: #0E76FF !important; }
.figma-search-group { display: flex; align-items: center; gap: 12px; margin-left: auto; }
.figma-search-input { width: 256px; height: 38px; }
.figma-search-input >>> .el-input__inner { height: 38px !important; line-height: 38px !important; border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; color: #1D2129; font-size: 14px; background: white; }
.figma-search-input >>> .el-input__inner::placeholder { color: #8C9BB4; }
.figma-search-input >>> .el-input__inner:focus { outline-color: #0E76FF; }
.figma-search-input >>> .el-select__caret { line-height: 38px; }
.figma-btn-search { width: 84px; height: 38px; min-height: 38px; border-radius: 10px !important; border: none !important; outline: 1px #0E76FF solid !important; outline-offset: -1px; color: #0E76FF !important; background: white !important; font-size: 14px; font-weight: 500; padding: 0 !important; display: inline-flex; align-items: center; justify-content: center; gap: 6px; }
.figma-btn-search:hover { background: rgba(14, 118, 255, 0.08) !important; }
.figma-table-section { flex: 0 0 auto; min-height: 0; padding: 12px 24px 0; overflow: auto; }
.figma-table-section >>> .el-table { border-radius: 0; overflow: hidden; border: none; }
.figma-table-section >>> .el-table::before { display: none; }
.figma-table-section >>> .el-table__header th { background: #EBF2FA !important; border: none !important; padding: 0 !important; }
.figma-table-section >>> .el-table__body td { border: none !important; padding: 0 !important; }
.figma-table-section >>> .el-table .cell { height: 50px; line-height: 50px; padding-left: 24px; padding-right: 24px; }
.action-links { display: flex; align-items: center; justify-content: flex-start; white-space: nowrap; }
.action-link { color: #0E76FF; font-size: 14px; cursor: pointer; text-decoration: none; font-weight: inherit; }
.action-link:hover { opacity: 0.85; }
.link-space { width: 16px; display: inline-block; }
.status-tag { display: inline-block; min-width: 66px; height: 28px; line-height: 26px; padding: 0 12px; box-sizing: border-box; border-radius: 8px; font-size: 14px; font-weight: 400; text-align: center; }
.status-pending { color: #FF6900; background: rgba(255, 105, 0, 0.10); border: 1px solid #FF6900; }
.status-approved { color: #0E76FF; background: rgba(14, 118, 255, 0.10); border: 1px solid #0E76FF; }
.status-default { color: #8C9BB4; background: rgba(140, 155, 180, 0.10); border: 1px solid #8C9BB4; }
.figma-pagination { display: flex; align-items: center; justify-content: flex-end; padding: 18px 22px 24px; gap: 8px; flex-shrink: 0; }
.pagination-total { font-size: 14px; color: #1D2129; margin-right: 0; line-height: 22px; }
.figma-pagination >>> .el-pagination { display: flex; align-items: center; padding: 0; }
.figma-pagination >>> .btn-prev,
.figma-pagination >>> .btn-next { width: 32px; height: 32px; min-width: 32px; border-radius: 2px; background: white; padding: 0; }
.figma-pagination >>> .el-pager li { min-width: 32px; height: 32px; line-height: 32px; border-radius: 8px; color: #1D2129; font-weight: 600; }
.figma-pagination >>> .el-pager li.active { background: #E8F3FF; color: #0E76FF; }
.draft-add-child { flex: 1; min-height: 0; overflow: auto; }
.pagination-size-select { width: 92px; margin-left: 0; }
.pagination-size-select >>> .el-input__inner { height: 32px !important; line-height: 32px !important; border-radius: 8px; background: #F2F3F5; border: none; font-size: 14px; color: #1D2129; }

@media (max-width: 1024px) {
  .figma-header-row { align-items: flex-start; gap: 12px; flex-direction: column; }
  .figma-search-group { width: 100%; margin-left: 0; flex-wrap: wrap; }
  .figma-search-input { width: min(256px, calc(100vw - 150px)); }
}
</style>
